var _path, _path2, _path3, _rect, _g, _path4, _path5, _rect2, _g2, _rect3, _g3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNectar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140 275C65.4 275 5 214.6 5 140C5 65.4 65.4 5 140 5C214.6 5 275 65.4 275 140C275 214.6 214.6 275 140 275Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.418 168.933L116.445 169.594L119.582 207.465L127.555 206.804L124.418 168.933Z",
    fill: "#3A3A3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169 169.2H161V207.2H169V169.2Z",
    fill: "#3A3A3A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_220",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 220,
    width: 90,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 220,
    width: 90,
    height: 15,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.5 232.2C168.972 232.2 188 229.961 188 227.2C188 224.439 168.972 222.2 145.5 222.2C122.028 222.2 103 224.439 103 227.2C103 229.961 122.028 232.2 145.5 232.2Z",
    fill: "#BFC3CE"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.5 225.2C125.165 225.2 133 220.275 133 214.2C133 208.125 125.165 203.2 115.5 203.2C105.835 203.2 98 208.125 98 214.2C98 220.275 105.835 225.2 115.5 225.2Z",
    fill: "#3A3A3A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M173.5 225.2C183.165 225.2 191 220.275 191 214.2C191 208.125 183.165 203.2 173.5 203.2C163.835 203.2 156 208.125 156 214.2C156 220.275 163.835 225.2 173.5 225.2Z",
    fill: "#3A3A3A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_220",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 207,
    width: 10,
    height: 10
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 207,
    width: 10,
    height: 10,
    fill: "url(#pattern1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.5 214.2C106.881 214.2 108 213.081 108 211.7C108 210.319 106.881 209.2 105.5 209.2C104.119 209.2 103 210.319 103 211.7C103 213.081 104.119 214.2 105.5 214.2Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_220",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 179,
    y: 207,
    width: 10,
    height: 10
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 207,
    width: 10,
    height: 10,
    fill: "url(#pattern2)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.5 214.2C185.881 214.2 187 213.081 187 211.7C187 210.319 185.881 209.2 184.5 209.2C183.119 209.2 182 210.319 182 211.7C182 213.081 183.119 214.2 184.5 214.2Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4001 116.2L98.1001 123.4C98.0001 125.9 95.9001 127.8 93.4001 127.7C90.9001 127.6 89.0001 125.5 89.1001 123L89.4001 115.8C89.5001 113.3 91.6001 111.4 94.1001 111.5C96.6001 111.6 98.5001 113.7 98.4001 116.2Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113 82C113 83.5 112.4 84.8 111.5 85.8C111.1 86.1 110.8 86.3 110.5 86.6C106.2 90.4 103.1 95.6 102 101.5C101.9 101.8 101.9 102.1 101.8 102.4C101.2 104.7 99 106.4 96.5 106.4C93.7 106.4 91.5 104.4 91.1 101.8C91.1 101.4 91 101 91 100.6C91 100.4 91 100.1 91 99.9C91 90.3 96.3 81.9 104.3 77.4C104.7 77.2 105.1 76.9 105.6 76.7C106.2 76.5 106.9 76.3 107.5 76.3C110.5 76.5 113 79 113 82Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M139.7 191.8C179.465 191.8 211.7 159.564 211.7 119.8C211.7 80.0355 179.465 47.8 139.7 47.8C99.9356 47.8 67.7001 80.0355 67.7001 119.8C67.7001 159.564 99.9356 191.8 139.7 191.8Z",
    fill: "url(#paint0_linear_1_220)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M143.7 157.6C145.081 157.6 146.2 156.481 146.2 155.1C146.2 153.719 145.081 152.6 143.7 152.6C142.319 152.6 141.2 153.719 141.2 155.1C141.2 156.481 142.319 157.6 143.7 157.6Z",
    fill: "#FC6B00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M172.2 142.6C173.581 142.6 174.7 141.481 174.7 140.1C174.7 138.719 173.581 137.6 172.2 137.6C170.819 137.6 169.7 138.719 169.7 140.1C169.7 141.481 170.819 142.6 172.2 142.6Z",
    fill: "#FC6B00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M172.2 108.6C173.581 108.6 174.7 107.481 174.7 106.1C174.7 104.719 173.581 103.6 172.2 103.6C170.819 103.6 169.7 104.719 169.7 106.1C169.7 107.481 170.819 108.6 172.2 108.6Z",
    fill: "#FC6B00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M149.2 125.6C150.581 125.6 151.7 124.481 151.7 123.1C151.7 121.719 150.581 120.6 149.2 120.6C147.819 120.6 146.7 121.719 146.7 123.1C146.7 124.481 147.819 125.6 149.2 125.6Z",
    fill: "#FC6B00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122.2 141.6C123.581 141.6 124.7 140.481 124.7 139.1C124.7 137.719 123.581 136.6 122.2 136.6C120.819 136.6 119.7 137.719 119.7 139.1C119.7 140.481 120.819 141.6 122.2 141.6Z",
    fill: "#FC6B00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2001 139.6C89.5808 139.6 90.7001 138.481 90.7001 137.1C90.7001 135.719 89.5808 134.6 88.2001 134.6C86.8194 134.6 85.7001 135.719 85.7001 137.1C85.7001 138.481 86.8194 139.6 88.2001 139.6Z",
    fill: "#FC6B00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M100.2 118.6C101.581 118.6 102.7 117.481 102.7 116.1C102.7 114.719 101.581 113.6 100.2 113.6C98.8194 113.6 97.7001 114.719 97.7001 116.1C97.7001 117.481 98.8194 118.6 100.2 118.6Z",
    fill: "#FC6B00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2001 102.6C88.5808 102.6 89.7001 101.481 89.7001 100.1C89.7001 98.7193 88.5808 97.6 87.2001 97.6C85.8194 97.6 84.7001 98.7193 84.7001 100.1C84.7001 101.481 85.8194 102.6 87.2001 102.6Z",
    fill: "#FC6B00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M129.2 107.6C130.581 107.6 131.7 106.481 131.7 105.1C131.7 103.719 130.581 102.6 129.2 102.6C127.819 102.6 126.7 103.719 126.7 105.1C126.7 106.481 127.819 107.6 129.2 107.6Z",
    fill: "#FC6B00"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M113.2 83.6C114.581 83.6 115.7 82.4807 115.7 81.1C115.7 79.7193 114.581 78.6 113.2 78.6C111.819 78.6 110.7 79.7193 110.7 81.1C110.7 82.4807 111.819 83.6 113.2 83.6Z",
    fill: "#FC6B00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M149.2 92.6C150.581 92.6 151.7 91.4807 151.7 90.1C151.7 88.7193 150.581 87.6 149.2 87.6C147.819 87.6 146.7 88.7193 146.7 90.1C146.7 91.4807 147.819 92.6 149.2 92.6Z",
    fill: "#FC6B00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M160.2 71.6C161.581 71.6 162.7 70.4807 162.7 69.1C162.7 67.7193 161.581 66.6 160.2 66.6C158.819 66.6 157.7 67.7193 157.7 69.1C157.7 70.4807 158.819 71.6 160.2 71.6Z",
    fill: "#FC6B00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M146.2 56.6C147.581 56.6 148.7 55.4807 148.7 54.1C148.7 52.7193 147.581 51.6 146.2 51.6C144.819 51.6 143.7 52.7193 143.7 54.1C143.7 55.4807 144.819 56.6 146.2 56.6Z",
    fill: "#FC6B00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M113.2 168.6C114.581 168.6 115.7 167.481 115.7 166.1C115.7 164.719 114.581 163.6 113.2 163.6C111.819 163.6 110.7 164.719 110.7 166.1C110.7 167.481 111.819 168.6 113.2 168.6Z",
    fill: "#FC6B00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M126.2 181.6C127.581 181.6 128.7 180.481 128.7 179.1C128.7 177.719 127.581 176.6 126.2 176.6C124.819 176.6 123.7 177.719 123.7 179.1C123.7 180.481 124.819 181.6 126.2 181.6Z",
    fill: "#FC6B00"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M210.7 119.4C210.7 159.2 178.5 191.4 138.7 191.4C136.6 191.4 134.4 191.3 132.3 191.1C161.5 184 183.7 148.1 183.7 104.9C183.7 86.9 179.8 70.1 173.2 56.2C195.5 68.4 210.7 92.1 210.7 119.4Z",
    fill: "#FD6863"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M128.7 60.6C130.357 60.6 131.7 59.7045 131.7 58.6C131.7 57.4954 130.357 56.6 128.7 56.6C127.043 56.6 125.7 57.4954 125.7 58.6C125.7 59.7045 127.043 60.6 128.7 60.6Z",
    fill: "#009D00"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M132.7 61.6C134.357 61.6 135.7 60.7045 135.7 59.6C135.7 58.4954 134.357 57.6 132.7 57.6C131.043 57.6 129.7 58.4954 129.7 59.6C129.7 60.7045 131.043 61.6 132.7 61.6Z",
    fill: "#009D00"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M131.7 64.6C133.357 64.6 134.7 63.7045 134.7 62.6C134.7 61.4954 133.357 60.6 131.7 60.6C130.043 60.6 128.7 61.4954 128.7 62.6C128.7 63.7045 130.043 64.6 131.7 64.6Z",
    fill: "#009D00"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M127.7 65.6C129.357 65.6 130.7 64.7045 130.7 63.6C130.7 62.4954 129.357 61.6 127.7 61.6C126.043 61.6 124.7 62.4954 124.7 63.6C124.7 64.7045 126.043 65.6 127.7 65.6Z",
    fill: "#009D00"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M125.7 62.6C127.357 62.6 128.7 61.7045 128.7 60.6C128.7 59.4954 127.357 58.6 125.7 58.6C124.043 58.6 122.7 59.4954 122.7 60.6C122.7 61.7045 124.043 62.6 125.7 62.6Z",
    fill: "#009D00"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M128.7 62.6C130.357 62.6 131.7 61.7045 131.7 60.6C131.7 59.4954 130.357 58.6 128.7 58.6C127.043 58.6 125.7 59.4954 125.7 60.6C125.7 61.7045 127.043 62.6 128.7 62.6Z",
    fill: "#009D00"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M110.5 110.9C109.6 107.4 111.7 103.9 115.1 103C118.6 102.1 122.1 104.2 123 107.6",
    stroke: "#4C1A1D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M148.5 101.9C147.6 98.4 149.7 94.9 153.1 94C156.6 93.1 160.1 95.2 161 98.6",
    stroke: "#4C1A1D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M149 108.5C150.5 114.4 147 120.4 141.2 121.9C135.4 123.4 129.3 119.9 127.8 114.1",
    fill: "#FFF3F3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3001 128.6C80.3001 128.6 69.3001 119.6 69.3001 105.6C69.3001 105.6 62.8001 100.1 64.8001 85.1",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8001 95.1C76.8001 95.1 71.8001 105.1 69.3001 105.6C59.7001 107.5 54.8 88.1 54.8 88.1",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M196.4 131.6C196.4 131.6 216.4 118.6 213.4 98.6C213.4 98.6 220.4 88.6 216.4 79.6",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M204.4 90.6C204.4 90.6 206.4 100.6 213.4 98.6C220.4 96.6 226.6 93.6 225 84.1",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_220",
    transform: "scale(0.0111111 0.0666667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1_220",
    transform: "scale(0.1)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1_220",
    transform: "scale(0.1)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_220",
    x1: 77.2303,
    y1: 103.344,
    x2: 216.518,
    y2: 140.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5924,
    stopColor: "#FD8665"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_220",
    width: 90,
    height: 15,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAGmAAACBQAAAtT/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAA8AWgMBIgACEQEDEQH/xACIAAACAwEBAAAAAAAAAAAAAAAEBQABBgMCAQEAAAAAAAAAAAAAAAAAAAAAEAAABwADAQEAAAAAAAAAAAAAAQIDBAUGIAcXERYRAAIABAMECAcAAAAAAAAAAAECABEDBCEx0RKSEwUQQYGyk9MUNVGRobGiY4MSAQAAAAAAAAAAAAAAAAAAACD/2gAMAwEAAhEDEQAAAMXqsloR4Ys6B8qySBnUP2CJ0bVUf//aAAgBAgABBQDl/9oACAEDAAEFAOX/2gAIAQEAAQUAr6uVYLg9bSHks9YxErLrikHnFGPOKMecUY84oxJ60rVk91iRN2uUn1pCEuehyHb7lltnUbVCC1mxI0667+fr7kHr7kO6zWms9XshIv8AeOKsJGhdIf/aAAgBAgIGPwBf/9oACAEDAgY/AF//2gAIAQEBBj8ACUAAJyLExt3FyFU5bA1nANW5dlGa4CfyEYl946xm+8dYzfeOsZvvHWM33jrA4FZ6R+M5z3pwxo3RLyw2gJfYQWZlqKJzIwPRtWXEL/rBb6CcBaVtc1FGTG3qN3QICvye4qMBi3BqifZsGMeR3B/jV8uBtcivZ9cqD6R7DfeA+kYchvvAfSDwuR3ITq2qNWfcj2S48Gr5cMRYXFNDkvp6uHbIQ3rluFUmZD02QD8R0f/Z"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_1_220",
    width: 10,
    height: 10,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAF0AAABgwAAAa//2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAoACgMBIgACEQEDEQH/xABoAAEBAAAAAAAAAAAAAAAAAAAABgEBAAAAAAAAAAAAAAAAAAAAABABAQEBAAAAAAAAAAAAAAAABQAQBBEAAAYDAAAAAAAAAAAAAAAAESECEgMEIAFBEgEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAAACfnw//2gAIAQIAAQUAv//aAAgBAwABBQC//9oACAEBAAEFAADhOs/f/9oACAECAgY/AH//2gAIAQMCBj8Af//aAAgBAQEGPwC3NfkbPCO0Jc0gLuH/2Q=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNectar);
export default __webpack_public_path__ + "static/media/nectar.d97e833960e4c9def34405259b31da88.svg";
export { ForwardRef as ReactComponent };